/**
 * Story block index: highlights the section being read and fills the track as the reader moves through.
 */
module.exports = function () {
    document.querySelectorAll('.story-block .index').forEach(function (index) {
        const section = index.closest('.story-block');
        const links = Array.from(index.querySelectorAll('a'));
        const panels = links.map(function (link) {
            return section.querySelector(link.getAttribute('href'));
        }).filter(Boolean);
        const fill = index.querySelector('.track .fill');

        if (!panels.length)
            return;

        const update = function () {
            const marker = window.innerHeight * .4;
            let active = 0;

            panels.forEach(function (panel, i) {
                if (panel.getBoundingClientRect().top <= marker)
                    active = i;
            });

            links.forEach(function (link, i) {
                link.classList.toggle('is-active', i === active);
            });

            if (fill) {
                const box = section.querySelector('.panels').getBoundingClientRect();
                const progress = (marker - box.top) / box.height;
                fill.style.height = (Math.max(0, Math.min(1, progress)) * 100) + '%';
            }
        };

        window.addEventListener('scroll', function () {
            requestAnimationFrame(update);
        }, {passive: true});
        window.addEventListener('resize', update);
        update();
    });
};
